import { Receipt } from "../models/receipt";
import { ItemRequestStatus, postItem } from "./generics";

const confirmReceiptDraft = async (
  id: number,
): Promise<ItemRequestStatus<Receipt>> => {
  return postItem<Receipt>(`/receipts/${id}/confirm_draft/`, {} as Receipt);
};

const discardReceiptDraft = async (
  id: number,
): Promise<ItemRequestStatus<Receipt>> => {
  return postItem<Receipt>(`/receipts/${id}/discard_draft/`, {} as Receipt);
};

const regenerateReceiptKude = async (
  id: number,
): Promise<ItemRequestStatus<Receipt>> => {
  return postItem<Receipt>(`/receipts/${id}/regenerate_kude/`, {} as Receipt);
};

export { confirmReceiptDraft, discardReceiptDraft, regenerateReceiptKude };
